/**
deferUntilNewTitle will attempt to wait until the document title changes before
executing the provided function.  If the title does not change within the time
given in timeout (in milliseconds, default 750), it will execute the function anyway.
*/
export function deferUntilNewTitle(fn: () => void, timeout = 750) {
  const startingTitle = window.document.title;
  const MINIMUM_TIMEOUT = 200;
  const ATTEMPT_INTERVAL = 100;
  const time = Math.max(timeout, MINIMUM_TIMEOUT);
  let timesup = false;
  function defer() {
    if (startingTitle !== window.document.title || timesup) {
      fn();
    } else {
      window.setTimeout(defer, ATTEMPT_INTERVAL);
    }
  }
  if (typeof window !== 'undefined') {
    window.setTimeout(() => (timesup = true), time);
    window.setTimeout(defer, ATTEMPT_INTERVAL);
  }
}
